import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import ProfileMenu from './ProfileMenu';
import MobileHamburger from './MobileHamburger';
import MobileMenu from './MobileMenu';
import './Main.css';
import { useAuth } from './AuthContext';
import { supabase } from './supabaseClient';
import { manualTriggerAutoArchive } from './utils/autoArchive';

function Settings() {
  const { user } = useAuth();
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [archiveResult, setArchiveResult] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [sidebarNarrow, setSidebarNarrow] = useState(false);

  useEffect(() => {
    document.title = "Settings";
  }, []);

  useEffect(() => {
    if (user) {
      fetchUserProfile();
    }
  }, [user]);

  async function fetchUserProfile() {
    try {
      const { data } = await supabase
        .from('profiles')
        .select('role')
        .eq('user_id', user.id)
        .single();
      setUserProfile(data);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  }

  async function handleManualArchive() {
    setLoading(true);
    setArchiveResult(null);
    
    try {
      const result = await manualTriggerAutoArchive();
      setArchiveResult(result);
    } catch (error) {
      setArchiveResult({
        success: false,
        message: `Error: ${error.message}`
      });
    } finally {
      setLoading(false);
    }
  }

  const isAdmin = userProfile && (userProfile.role === 'admin' || userProfile.role === 'super admin');

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f4f8f8' }}>
      <Sidebar onNarrowChange={setSidebarNarrow}/>
      <div style={{ flex: 1, padding: 32, width: '100%', overflowX: 'auto' }}>
        <div className="header">
          <div className="header">
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              {/* Mobile Hamburger Menu */}
              <MobileHamburger
                isOpen={showMobileMenu}
                onToggle={() => setShowMobileMenu(prev => !prev)}
              />
              <div className="title-text">Settings</div>
            </div>
          </div>
          <ProfileMenu />
        </div>
        {/* Mobile Dropdown Menu */}
        <MobileMenu 
          isOpen={showMobileMenu} 
          onClose={() => setShowMobileMenu(false)} 
        />
        
        {isAdmin && (
          <div style={{
            background: 'white',
            padding: 24,
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            marginBottom: 24
          }}>
            <h3 style={{ marginTop: 0, marginBottom: 16, color: '#333' }}>
              Auto-Archive Management
            </h3>
            <p style={{ color: '#666', marginBottom: 20 }}>
              The system automatically archives resolved incidents after 24 hours. You can manually trigger the auto-archive process for testing purposes.
            </p>
            
            <button
              onClick={handleManualArchive}
              disabled={loading}
              style={{
                background: loading ? '#ccc' : '#2196f3',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: 8,
                fontSize: 16,
                cursor: loading ? 'not-allowed' : 'pointer',
                marginBottom: 16
              }}
            >
              {loading ? 'Processing...' : 'Manually Trigger Auto-Archive'}
            </button>

            {archiveResult && (
              <div style={{
                padding: 16,
                borderRadius: 8,
                background: archiveResult.success ? '#e8f5e8' : '#ffebee',
                border: `1px solid ${archiveResult.success ? '#4caf50' : '#f44336'}`,
                color: archiveResult.success ? '#2e7d32' : '#c62828'
              }}>
                <strong>Result:</strong> {archiveResult.message}
                {archiveResult.archivedCount !== undefined && (
                  <div style={{ marginTop: 8 }}>
                    <strong>Archived incidents:</strong> {archiveResult.archivedCount}
                    {archiveResult.archivedIncidents && archiveResult.archivedIncidents.length > 0 && (
                      <div style={{ marginTop: 4, fontSize: 14 }}>
                        IDs: {archiveResult.archivedIncidents.join(', ')}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <div style={{
          background: 'white',
          padding: 24,
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginTop: 0, marginBottom: 16, color: '#333' }}>
            General Settings
          </h3>
          <p style={{ color: '#666' }}>
            Additional settings will be available here in future updates.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Settings; 